export const externalReviewerFieldsMapSF = {
  direction: 'in',
  Id: 'id',
  Additional_comments__c: 'additionalComments',
  Contact__c: 'contact',
  Demographic_experience__c: {
    key: 'demographicExperience',
    in: (rev) => {
      return rev.Demographic_experience__c?.split(';') ?? []
    },
    out: (arr) => {
      return arr.join(';')
    }
  },
  Expertise_other__c: 'expertiseOther',
  Fields_of_expertise__c: {
    key: 'fieldOfExpertise',
    in: (rev) => {
      return rev.Fields_of_expertise__c?.split(';') ?? []
    },
    out: (arr) => {
      return arr.join(';')
    }
  },
  Indigenous__c: 'indigenous',
  Language_preference__c: {
    key: 'languagePreference',
    in: (rev) => {
      return rev.Language_preference__c?.split(';') ?? []
    },
    out: (arr) => {
      return arr.join(';')
    }
  },
  Name: 'name',
  Professional_volunteer_experience__c: 'professionalVolunteerExperience',
  Project_types__c: {
    key: 'projectTypes',
    in: (rev) => {
      return rev.Project_types__c?.split(';') ?? []
    },
    out: (arr) => {
      return arr.join(';')
    }
  },
  Regional_experience__c: {
    key: 'regionalExperience',
    in: (rev) => {
      return rev.Regional_experience__c?.split(';') ?? []
    },
    out: (arr) => {
      return arr.join(';')
    }
  },
  Sector_experience__c: 'sectorExperience',
  Status__c: 'status'
}

export interface ExternalReviewer {
  id: string
  additionalComments: string
  contactExternalId: string
  contact: string
  demographicExperience: string[]
  email: string
  expertiseOther: string
  fieldOfExpertise: string[]
  indigenous: string
  jobTitle: string
  languagePreference: string[]
  name: string
  org: string
  organization: string
  organizationPrimaryAffiliation: string
  gapOrg: string
  gapOrganizationPrimaryAffiliation: string
  professionalVolunteerExperience: string
  projectTypes: string[]
  regionalExperience: string[]
  sectorExperience: string
  status: string
}
